import React, { useEffect } from "react";
import { useState } from "react";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Chip,
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  TextField,
  Typography,
  useTheme,
  useMediaQuery,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox
} from "@mui/material";
import { tokens } from "../../Theme/theme";
import {
  CircleNotifications,
  Close,
  LocalSeeOutlined,
  NotificationsOffOutlined,
} from "@mui/icons-material";
import { Header } from "../global/Header";
import CustomizedNotification from "./CustomizedNotification";
import BASE_URL from "../../NetworkConfig/ApiConfig";
import { ArrowRightIcon } from "@mui/x-date-pickers";
import SelectCommunitiesPopup from "../Utils/SelectCommunitiesPopup";
import searchIcon from '../../assets/search.svg'







const SendNotification = () => {
  const theme = useTheme();
  const preset_key = "marketing_admin";
  const cloud_name = "dx8qieggt";
  const colors = tokens(theme.palette.mode);
  const [open, setOpen] = React.useState(false);
  const [disable, setdisable] = React.useState(false);
  const [severity, setseverity] = useState("");
  const [imageupload, setimageupload] = useState(false);
  const [currentFile, setCurrentFile] = useState("")
  // const [selectedfield, setselectedfield] = useState("buzz_name");
  const [imageuploadtext, setimageuploadtext] = useState("Select Image");
  const [AlertMessage, setAlertMessage] = useState("");
  const [recipientType, setRecipientType] = useState("0")
  const [customCommunities, setCustomCommunities] = useState([])
  const [communityTypes, setCommunityTypes] = useState([])
  const [showCMAddPopup, setShowCMAddPopup] = useState(false)
  const [searchQuery, setSearchQuery] = useState("")
  const [searchedCommunities, setSearchedCommunities] = useState([])
  const [nonSearchedCommunities, setNonSearchedCommunities] = useState([])
  const [selectedPhoto, setSelectedPhoto] = useState(null)
  const isMobileScreen = useMediaQuery('(max-width:500px)');
  const isTabScreen = useMediaQuery('(max-width:1200px)')






  const handleClick = () => {
    setOpen(true);
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  const [title, settitle] = useState("");
  const [message, setmessage] = useState("");
  const [image, setimage] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    setSelectedPhoto(file);
  };




  const formData = new FormData();
  const calculatePayloadSize = (payload) => {
    const jsonString = JSON.stringify(payload);
    const encoder = new TextEncoder();
    const encodedPayload = encoder.encode(jsonString);
    const payloadSizeInBytes = encodedPayload.length / (1024 * 1024);
    return payloadSizeInBytes;
  };

  const sendNotification = async () => {

    const communitiesList = customCommunities.map(cc => cc._id)
    const data = new FormData();
    data.append("recipientType", recipientType);
    data.append("title", title);
    data.append("description", message);
    data.append("communityTypes", JSON.stringify(communityTypes));
    data.append("communities", JSON.stringify(communitiesList));

    // Ensure mediaUrl is a File object before appending
    if (selectedPhoto) {
      if (selectedPhoto instanceof File) {
        data.append("media", selectedPhoto);
      } else {
        alert("Please select a valid image");
      }
    }

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${BASE_URL}/notify/send-cn`, {
        method: "PUT",
        headers: {
          "auth-token": token,  // ✅ Do NOT set Content-Type manually
        },
        body: data
      });

      const json = await response.json();

      if (json.success === true) {
        alert("Notification has been sent");
      } else {
        alert(`${json.response}`);
      }

    } catch (error) {
      console.error("Submission error:", error);
      alert("Error sharing data in noticeboard!");
    }

  };

  const searchCommunities = async (q) => {
    // setloading(true);
    const token = localStorage.getItem("token");
    const response = await fetch(`${BASE_URL}/spaces/communities/search-in-all?q=${q}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "auth-token": token,
      },
    });
    const data = await response.json();
    if (data.success === true) {
      setSearchedCommunities(data.data)
    }
  };

  const [currentPage, setCurrentPage] = useState(1)
  const [hasEnded, setHasEnded] = useState(false)
  const [communitiesLoading, setCommunitiesLoading] = useState(false)

  useEffect(() => {
    getAllCommunities(1)
  }, [])

  const getAllCommunities = async (page) => {

    setCommunitiesLoading(true)

    if (page == 1) {
      setNonSearchedCommunities([])
      setHasEnded(false)
    }

    const token = localStorage.getItem("token");
    const response = await fetch(`${BASE_URL}/spaces/communities/get-all?page=${page}&limit=${30}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "auth-token": token,
      },
    });
    const data = await response.json();
    if (data.success === true) {
      setNonSearchedCommunities(pre => page == 1 ? data.data : [...pre, ...data.data])
      setCurrentPage(page)
      if (data.data.length < 30) {
        setHasEnded(true)
      }
    }
  };

  useEffect(() => {
    if (searchQuery.length > 0) {
      const delayDebounceFn = setTimeout(() => {
        searchCommunities(searchQuery);
      }, 500); // 500ms delay

      return () => clearTimeout(delayDebounceFn);
    } else {
      setSearchedCommunities([]); // Clear results when input is empty
    }
  }, [searchQuery]);


  return (
    <Box m={"20px"} paddingBottom={(isMobileScreen || isTabScreen) ? "20px" : "0px"}>
      <Box display={"flex"} justifyContent="space-between">
        <Header
          title={"Send Notification"}
          subtitle={"Enabled for the Marketing 'PROMOTIONALS'"}
        />
      </Box>

      <Box
        display={"grid"}
        gridTemplateColumns="repeat(12,1fr)"
        gap="20px"
        sx={{}}>

        {/* <CustomizedNotification span={(isMobileScreen || isTabScreen) ? "span 12" : "span 6" } /> */}

        <Box
          gridColumn={(isMobileScreen || isTabScreen) ? "span 12" : "span 5"}
          display="flex"
          sx={{
            px: '20px',
            py: '20px',
            borderRadius: "15px",
            background: "#ffffff08"
          }}
          flexDirection={'column'}
        >

          <Box sx={{
            flexDirection: 'row',
            display: 'flex',
            borderRadius: "10px",
            border: "1px solid #aaaaaa10",
            background: "#00000070",
            marginBottom: "10px"
          }}>

            <textarea placeholder="Notification title..."
              rows={1}
              value={title}
              onChange={(v) => {
                settitle(v.target.value)
              }}
              style={{
                outline: 'none',
                backgroundColor: "#aaaaaa00",
                borderWidth: 0,
                paddingLeft: "15px",
                paddingRight: "15px",
                flex: 1,
                display: 'flex',
                fontSize: "14px",
                paddingBlock: "14px",
                fontFamily: 'poppins-reg',
                color: "white"
              }} />


          </Box>

          <Box sx={{
            flexDirection: 'row',
            display: 'flex',
            borderRadius: "10px",
            border: "1px solid #aaaaaa10",
            background: "#00000070"
          }}>

            <textarea placeholder="Notification body..."
              rows={3}
              value={message}
              onChange={(v) => {
                setmessage(v.target.value)
              }}
              style={{
                outline: 'none',
                backgroundColor: "#aaaaaa00",
                borderWidth: 0,
                paddingLeft: "15px",
                paddingRight: "15px",
                paddingTop: "12px",
                flex: 1,
                display: 'flex',
                fontSize: "14px",
                paddingBottom: "12px",
                fontFamily: 'poppins-reg',
                color: "white"
              }} />


          </Box>

          <Box display={"flex"} flexDirection={'column'} sx={{ marginTop: '10px' }}>

            <input type="file" accept="image/*" onChange={handleFileChange} style={{ marginTop: "10px", fontFamily: "poppins-reg", width: "100%" }} />

          </Box>

          <Box sx={{ height: "1px", background: "#aaaaaa10", marginBlock: "20px" }} />

          <Box sx={{
            flexDirection: "column",
            display: "flex",
          }}>
            {/* 
            <Typography style={{ fontFamily: "poppins-reg", fontSize: "14px", color: "#ffffff", }} >
              Select notification recipients
            </Typography> */}

            <FormControl>
              <RadioGroup
                row
                value={recipientType}
                onChange={(e) => setRecipientType(e.target.value)}
              >
                <FormControlLabel sx={{
                  alignItems: "center",
                  ".MuiFormControlLabel-label": {
                    fontFamily: "poppins-reg",
                    fontSize: "13px",
                    lineHeight: "20px",
                    display: "flex",
                    alignItems: "center"
                  }
                }} value="1" control={<Radio sx={{
                  color: "#666",                    // unselected color
                  "&.Mui-checked": {
                    color: "#943bff"                // ✅ selected color
                  }
                }} />} label="All Users" />
                <FormControlLabel sx={{
                  alignItems: "center",
                  ".MuiFormControlLabel-label": {
                    fontFamily: "poppins-reg",
                    fontSize: "13px",
                    lineHeight: "20px",
                    display: "flex",
                    alignItems: "center"
                  }
                }} value="2" control={<Radio sx={{
                  color: "#666",                    // unselected color
                  "&.Mui-checked": {
                    color: "#943bff"                // ✅ selected color
                  }
                }} />} label="Community Type" />
                <FormControlLabel sx={{
                  alignItems: "center",
                  ".MuiFormControlLabel-label": {
                    fontFamily: "poppins-reg",
                    fontSize: "13px",
                    lineHeight: "20px",
                    display: "flex",
                    alignItems: "center"
                  }
                }} value="3" control={<Radio sx={{
                  color: "#666",                    // unselected color
                  "&.Mui-checked": {
                    color: "#943bff"                // ✅ selected color
                  }
                }} />} label="Individual Communities" />
              </RadioGroup>
            </FormControl>

            {
              recipientType == 2 && (
                <Box sx={{
                  display: "flex", flexDirection: "column", background: "#ffffff08", alignSelf: "flex-start",
                  maxWidth: "50%", minWidth: "35%", marginTop: "15px", marginBottom: "10px",
                  borderRadius: "15px", paddingBlock: "15px", paddingInline: "10px"
                }}>
                  <Typography style={{ fontFamily: "poppins-reg", fontSize: "14px", color: "#ffffff", marginLeft: "5px", marginBottom: "10px", marginRight: "20px" }} >
                    Select community types
                  </Typography>
                  <Box sx={{ height: "1px", background: "#aaaaaa10", marginBottom: "5px" }} />


                  {
                    ["Campus", "Business"].map((item, index) => (
                      <FormControlLabel
                        value={item}
                        control={
                          <Checkbox
                            checked={communityTypes.includes(item)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                if (!communityTypes.includes(item)) {
                                  setCommunityTypes(prev => [...prev, item])
                                }
                              } else {
                                if (communityTypes.includes(item)) {
                                  const filteredList = communityTypes.filter(ct => ct != item)
                                  setCommunityTypes(filteredList)
                                }
                              }

                            }}
                            sx={{
                              color: "#666",                    // unselected
                              "&.Mui-checked": {
                                color: "#943bff"                // selected
                              },
                              "&:hover": { backgroundColor: "rgba(0,224,255,0.08)" }
                            }}
                          />
                        }
                        label={item}
                        sx={{
                          m: 0,
                          alignItems: "center",
                          ".MuiFormControlLabel-label": {
                            fontFamily: "poppins-reg",
                            fontSize: 13,
                            lineHeight: "20px",
                            color: "#ddd",
                            display: "flex",
                            alignItems: "center"
                          }
                        }}
                      />
                    ))
                  }

                </Box>
              )
            }

            {
              recipientType == "3" && (
                <Box
                  onClick={() => {
                    setShowCMAddPopup(true)
                  }}
                  sx={{
                    border: "1px solid #aaaaaa10",
                    borderRadius: "15px",
                    px: "15px",
                    py: "15px",
                    marginTop: "15px",
                    marginBottom: "10px",
                    maxWidth: "450px",
                    position: "relative",
                    flexDirection: "row",
                    alignItems: "center",
                    display: "flex",
                    cursor: "pointer"
                  }} >
                  <Typography style={{
                    flex: 1, display: 'flex',
                    fontFamily: "poppins-reg", fontSize: "14px", color: "#ffffff90",

                  }} >
                    Select Communities
                  </Typography>

                  <ArrowRightIcon style={{ color: "#ffffff90", fontSize: "18px", }} />

                </Box>
              )
            }

            {
              recipientType == "3" && (
                <Box sx={{
                  display: 'flex', flexWrap: 'wrap', gap: "10px", marginBottom: customCommunities.length > 0 ? "10px" : "0px"
                }}>
                  {
                    customCommunities.length > 0 && customCommunities.map((item, index) => (
                      <Box onClick={() => {
                        const newList = customCommunities.filter(dm => dm._id != item._id)
                        setCustomCommunities(newList)
                      }} key={index} sx={{
                        padding: "6px 12px",
                        borderRadius: 20,
                        background: "#943bff10",
                        fontSize: "12px",
                        cursor: 'pointer',
                        fontFamily: "poppins-reg",
                        color: "#943bff", flexDirection: 'row', display: 'flex',
                        alignItems: 'center'
                      }}>{item.name ? item.name : item.title}<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingLeft: "5px" }}><Close style={{ width: "15px", height: "15px" }} /></Box></Box>
                    ))
                  }
                </Box>
              )}

            {
              ["1", "2", "3"].includes(recipientType) && (
                <Typography style={{
                  fontFamily: "poppins-reg", fontSize: "13px", color: "#ffffff",
                  background: "#ffffff10",
                  paddingBlock: "10px",
                  paddingInline: "15px",
                  alignSelf: "flex-start",
                  marginTop: "10px",
                  borderTopRightRadius: "15px",
                  borderBottomLeftRadius: "15px",
                  borderBottomRightRadius: "15px"
                }} >
                  {recipientType == "1" ? "This notification will be sent to entire app users." :
                    recipientType == "2" ? `This notification will be sent to only the ${communityTypes.length > 0 ? communityTypes.join(", ").toLowerCase() : "selected type of"} community members.` :
                      recipientType == "3" ? `This notification will be sent to ${customCommunities.length ?? 0} communitites.` : ""}
                </Typography>
              )
            }




          </Box>

          <Button
            disabled={disable}
            startIcon={<CircleNotifications />}
            style={{
              borderRadius: 5,
              backgroundColor: "#706dea",
              // padding: "18px 36px",
              fontSize: "15px",
              paddingTop: '10px',
              paddingBottom: '10px',
              maxWidth: "450px",
              alignSelf: 'stretch',
              marginTop: '50px',
              color: 'white',
              fontFamily: 'poppins-reg',
              textTransform: 'none'
            }}
            onClick={() => {
              sendNotification()
            }}
            component="label"
          >
            Send Notification
          </Button>

        </Box>

      </Box>


      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {AlertMessage}
        </Alert>
      </Snackbar>

      <SelectCommunitiesPopup open={showCMAddPopup} onClose={() => setShowCMAddPopup(false)} onDelete={() => {
        //removeCommunity(selectedCommunity._id)
      }} >

        <Box sx={{ flexDirection: 'column', display: 'flex' }} >
          <Box sx={{
            flexDirection: 'row',
            backgroundColor: "#ffffff10",
            display: 'flex',
            borderRadius: "15px",
            border: "1px solid transparent",
            background:
              "linear-gradient(#ffffff10 0 0) padding-box, linear-gradient(#0b0b0f 0 0) padding-box, linear-gradient(45deg,#ffffff30, #00000000) border-box"
          }}>
            <img
              alt="search_icon"
              width="18px"
              height="18px"
              style={{
                objectFit: 'contain',
                filter: 'invert(1) hue-rotate(180deg) brightness(1)',
                alignSelf: 'center',
                marginLeft: "15px"
              }}
              src={searchIcon}
            />
            <input placeholder="Search community..."
              multiple={false}
              value={searchQuery}
              onChange={(v) => {
                setSearchQuery(v.target.value)
              }}
              style={{
                outline: 'none',
                backgroundColor: "#aaaaaa00",
                borderWidth: 0,
                paddingLeft: "15px",
                paddingRight: "15px",
                paddingTop: "10px",
                flex: 1,
                display: 'flex',
                fontSize: "15px",
                paddingBottom: "10px",
                fontFamily: 'poppins-reg',
                borderRadius: "100px",
                color: "white"
              }} />


          </Box>

          <Box sx={{ minHeight: "350px", display: 'flex', flexDirection: 'column', overflow: "scroll", maxHeight: "60vh" }}>

            {
              (searchQuery.length > 0 ? searchedCommunities : nonSearchedCommunities).map((community, index) => (
                <Box
                  onClick={() => {
                    setCustomCommunities(prev => {
                      const exists = prev.some(
                        cc => cc._id.toString() === community._id.toString()
                      );

                      if (exists) {
                        return prev.filter(
                          ct => ct._id.toString() !== community._id.toString()
                        );
                      }

                      return [...prev, community];
                    });
                  }}
                  display="flex"
                  alignItems="center"
                  px="0px"
                  py={"10px"}
                  sx={{
                    textDecoration: 'none', paddingY: "10px", flexDirection: 'row', alignItems: 'center',
                    display: 'flex', borderBottom: "1px solid #aaaaaa10", marginTop: index == 0 ? "10px" : "0"
                  }}
                >

                  <Box

                    sx={{
                      textDecoration: 'none', flex: 1, flexDirection: 'row', alignItems: 'center',
                      display: 'flex',
                    }}
                  >
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <img
                        alt="profile-user"
                        width="40px"
                        height="40px"
                        src={`${community.logo}`}
                        style={{
                          cursor: "pointer", objectFit: 'cover',
                          borderRadius: "50%",
                          border: "3px solid #ffffff10"
                        }}
                      />
                    </Box>
                    <Box sx={{ ml: "10px", mr: "10px", display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1, position: 'relative' }}>

                      <Typography color={"#ffffff"}
                        fontFamily={"poppins-reg"}
                        fontSize={"12px"} style={{
                          display: "-webkit-box",
                          WebkitLineClamp: 1,      // change to 3,4 if needed
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden"
                        }} >{community.title}</Typography>

                      <Box sx={{
                        display: 'flex', flexDirection: "row", alignItems: 'center', marginTop: "4px",
                        gap: "5px"
                      }}>
                        <Typography color={"#aaaaaa"}
                          fontFamily={"poppins-reg"}
                          style={{
                            borderRadius: "4px",
                            background: "#ffffff10",
                            paddingTop: "2px",
                            paddingBottom: "2px",
                            paddingLeft: "5px",
                            paddingRight: "5px"
                          }}
                          fontSize={"10.5px"}>{community.communityType}</Typography>
                      </Box>
                    </Box>

                    <FormControlLabel
                      value={community._id}
                      control={
                        <Checkbox
                          checked={customCommunities.some(cc => cc._id == community._id)}
                          onChange={(e) => {
                            e.stopPropagation();
                            if (e.target.checked) {
                              if (!customCommunities.some(cc => cc._id == community._id)) {
                                const newList = [...customCommunities, community]
                                setCustomCommunities(newList)
                              }
                            } else {
                              if (customCommunities.includes(community._id)) {
                                const filteredList = customCommunities.filter(ct => ct._id != community._id)
                                setCustomCommunities(filteredList)
                              }
                            }

                          }}
                          sx={{
                            color: "#666",                    // unselected
                            "&.Mui-checked": {
                              color: "#943bff"                // selected
                            },
                            "&:hover": { backgroundColor: "rgba(0,224,255,0.08)" }
                          }}
                        />
                      }
                      sx={{
                        m: 0,
                        alignItems: "center",
                        ".MuiFormControlLabel-label": {
                          fontFamily: "poppins-reg",
                          fontSize: 13,
                          lineHeight: "20px",
                          color: "#ddd",
                          display: "flex",
                          alignItems: "center"
                        }
                      }}
                    />

                  </Box>


                </Box>
              ))
            }

          </Box>

        </Box>



      </SelectCommunitiesPopup>
    </Box>
  );
};

export default SendNotification;
